import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 18 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("mask", {
      id: "i336679550__a",
      width: "18",
      height: "20",
      x: "0",
      y: "0",
      maskUnits: "userSpaceOnUse",
      style: {"mask-type":"alpha"}
    }, [
      _createElementVNode("path", {
        fill: "#fff",
        "fill-rule": "evenodd",
        d: "M8.91 0C7.756 0 6.818.92 6.789 2.067V2.06a2.06 2.06 0 0 0-4.122 0v.027A3.03 3.03 0 0 0 0 5.098V16.97A3.03 3.03 0 0 0 3.03 20H14.79a3.03 3.03 0 0 0 3.03-3.03V5.097a3.03 3.03 0 0 0-2.666-3.009v-.027a2.06 2.06 0 0 0-4.122 0v.006A2.12 2.12 0 0 0 8.91 0",
        "clip-rule": "evenodd"
      })
    ], -1),
    _createElementVNode("g", { mask: "url(#i336679550__a)" }, [
      _createElementVNode("path", {
        fill: "currentColor",
        d: "M-5.819-.243h29.396v23.587H-5.819z"
      })
    ], -1)
  ])))
}
export default { render: render }